'use client';

import { FilterMatchMode } from 'primereact/api';
import { DataTable, type DataTableFilterMeta, type DataTableProps, DataTableValueArray } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { type ChangeEvent, type ReactNode, useState } from 'react';

import styles from './CustomDataTable.module.scss';

type CustomDataTableProps<T> = DataTableProps<DataTableValueArray> & {
  children: ReactNode;
  title?: string;
  rows?: number;
  value: T[];
};

const CustomDataTable = <T extends object>({ children, title = '', rows = 10, ...rest }: CustomDataTableProps<T>) => {
  const [filters, setFilters] = useState<DataTableFilterMeta>({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  const header = (
    <div className="table-header">
      {title}
      <InputText
        type="search"
        onInput={(e: ChangeEvent<HTMLInputElement>) => {
          setFilters((value) => ({ ...value, global: { ...value.global, value: e.target.value } }));
        }}
        placeholder="Search..."
      />
    </div>
  );

  return (
    <DataTable
      {...rest}
      header={header}
      className={styles.database}
      paginator
      rows={rows}
      filters={filters}
      rowsPerPageOptions={[Math.ceil(rows / 2), rows, rows * 2]}
      paginatorTemplate={`FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport 
  RowsPerPageDropdown`}
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} items"
      emptyMessage="No items found."
    >
      {children}
    </DataTable>
  );
};

export default CustomDataTable;
